import { Directive } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import {RootScopeService} from '../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../core/rootscope-declare';

@Directive({
  selector: '[appTranslate]'
})
export class TranslateDirective {

  rootScopeData: RootScopeDeclare;

  constructor(public translate: TranslateService, private rootScopeService: RootScopeService) {
    translate.addLangs([
      'ar',
      'ca',
      'de',
      'en',
      'en_US',
      'es',
      'eu',
      'fi',
      'fr',
      'he',
      'hu',
      'it',
      'ja',
      'ko',
      'nl',
      'pl',
      'pt',
      'ru',
      'tr',
      'zh',
      'zhl'
    ]);
    translate.setDefaultLang('en_US');
    let selectedLang = 'en_US';
    this.getRootScopeData();
    if(this.rootScopeData['selectedLang']){
      selectedLang = this.rootScopeData.selectedLang;
    }
    translate.use(selectedLang).subscribe((res: any) => 
    {
      this.rootScopeData.translationsLoaded = true;
    });
    this.rootScopeData.selectedLang =  selectedLang;
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => this.rootScopeData = rootScopeData);
  }
}
